// const APP_ID = 'TUYA';
const APP_ID = 'RIPLEY WEB';
const CHANNEL = 'WEB';
const FORWARED_IP = '127.0.0.1';
// const USER_TYPE = 'CP';
const USER_TYPE = 'CI';
// const ENROLLMENT_TYPE = 'POCPRCDNVA';
const ENROLLMENT_TYPE = 'RIPLEYENR';
// const COUNTRY = 'COLOMBIA';
const COUNTRY = 'CHILE';

abstract class AbstractResponse {
    code : string;
    description : string;

    constructor() { }
};

export class KeyValue {
    key : string;
    value: string;

    constructor() { }
};

export class IdNowCommonResponse extends AbstractResponse {
    additionalResponseAttrs : KeyValue[];
};
export class QueryEnrollmentResponse extends AbstractResponse {
    commonUserDataRequest: CommonUserDataRequest;
    type : string;
    status : string;
    uuidDevice : string;
    uuidTransaction ?: string;
};

export class CommonParamsRequest {
    channel : string;
    appId: string;
    forwaredIp : string;

    constructor() { }
};

export class FinishEnrollmentRequest{
    commonParamsRequest : CommonParamsRequest;
    commonUserDataRequest: CommonUserDataRequest;
    uuidDevice : string;

    constructor() { }

    public static buildTuyaRequest(uploadFaceRequest: UploadFaceRequest): FinishEnrollmentRequest {
        let request = new FinishEnrollmentRequest()
        request.commonParamsRequest = uploadFaceRequest.commonParamsRequest;
        request.commonUserDataRequest = uploadFaceRequest.commonUserDataRequest;
        request.uuidDevice = uploadFaceRequest.uuidDevice;

        return request;
    }
};

export class CommonUserDataRequest {
    userId : string;
    userType: string;

    constructor() { }
};

export class QueryEnrollmentRequest {
    commonParamsRequest : CommonParamsRequest;
    commonUserDataRequest: CommonUserDataRequest;
    fromApp : boolean;
    uuidTransaction : string;

    constructor() { }

    public static buildTuyaRequest(uuidTransaction: string): QueryEnrollmentRequest {
        let request = new QueryEnrollmentRequest();

        request.fromApp = true;
        request.uuidTransaction = uuidTransaction;

        let commonParamsRequest = new CommonParamsRequest();
        commonParamsRequest.appId = APP_ID;
        commonParamsRequest.channel = CHANNEL;
        commonParamsRequest.forwaredIp = localStorage.getItem("clientIP");

        request.commonParamsRequest = commonParamsRequest;

        return request;
    }
};

export class UploadDniRequest {
    commonParamsRequest : CommonParamsRequest;
    commonUserDataRequest: CommonUserDataRequest;
    uuidDevice : String;
    country: string;
    pathId: string;
    base64FrontDni: string;
    base64BackDni: string;

    constructor() { }

    public static buildTuyaRequest(baseResponse: any, base64FrontDni: any, base64BackDni: any): UploadDniRequest {
        const commonParamsRequest = new CommonParamsRequest();
        commonParamsRequest.appId = APP_ID;
        commonParamsRequest.channel = CHANNEL;
        commonParamsRequest.forwaredIp = localStorage.getItem("clientIP");

        const uploadDniRequest = new UploadDniRequest();
        uploadDniRequest.commonParamsRequest = commonParamsRequest;
        uploadDniRequest.commonUserDataRequest = baseResponse.commonUserDataRequest;
        uploadDniRequest.country = COUNTRY;
        uploadDniRequest.uuidDevice = baseResponse.uuidDevice;
        uploadDniRequest.pathId = "2040"; 

        uploadDniRequest.base64FrontDni = base64FrontDni.replace('data:image/jpeg;base64,','').replace('data:image/png;base64,','');
        uploadDniRequest.base64BackDni = base64BackDni.replace('data:image/jpeg;base64,','').replace('data:image/png;base64,','');

        return uploadDniRequest;
    }
};

export class InitEnrollmentRequest {
    commonParamsRequest : CommonParamsRequest;
    commonUserDataRequest: CommonUserDataRequest;
    uuidDevice : string;
    os : string;
    enrollmentType : string;

    constructor() { }

    public static buildTuyaRequest(userId: string, uuidDevice: string): InitEnrollmentRequest {
        let commonParamsRequest = new CommonParamsRequest();
        commonParamsRequest.appId = APP_ID;
        commonParamsRequest.channel = CHANNEL;
        commonParamsRequest.forwaredIp  = localStorage.getItem("clientIP");

        let commonUserDataRequest = new CommonUserDataRequest();
        commonUserDataRequest.userId =  userId;
        // commonUserDataRequest.userType = 'CP';
        commonUserDataRequest.userType = USER_TYPE;

        let initEnrollmentRequest = new InitEnrollmentRequest();
        initEnrollmentRequest.commonParamsRequest = commonParamsRequest;
        initEnrollmentRequest.commonUserDataRequest = commonUserDataRequest;
        initEnrollmentRequest.uuidDevice = uuidDevice;
        initEnrollmentRequest.os = 'WEB';
        initEnrollmentRequest.enrollmentType = ENROLLMENT_TYPE;

        return initEnrollmentRequest;
    }
}

export class UploadFaceRequest {
    commonParamsRequest : CommonParamsRequest;
    commonUserDataRequest: CommonUserDataRequest;
    uuidDevice : string;
    base64Face: string;
    additionalsParams : { key: string, value: string }[];
    pathId: string;

    constructor() { }

    public static buildTuyaRequest(baseResponse: QueryEnrollmentResponse): UploadFaceRequest {
        let commonParamsRequest = new CommonParamsRequest();
        commonParamsRequest.appId = APP_ID;
        commonParamsRequest.channel = CHANNEL;
        commonParamsRequest.forwaredIp  = localStorage.getItem("clientIP");

        let uploadFaceRequest = new UploadFaceRequest();
        uploadFaceRequest.commonParamsRequest = commonParamsRequest;
        uploadFaceRequest.commonUserDataRequest = baseResponse.commonUserDataRequest;
        uploadFaceRequest.uuidDevice = baseResponse.uuidDevice;
        // uploadFaceRequest.pathId = "1686";
        uploadFaceRequest.pathId = "2041";

        return uploadFaceRequest;
    }
};

